// extracted by mini-css-extract-plugin
export default {"main-div":"Login_main-div__jUU+J","login-btn":"Login_login-btn__kMrau","error-message":"Login_error-message__3zbMq"};